export const aboutData = {
  name: 'Pedro Riccio',
  title: 'Engenheiro de Software',
  title_en: 'Software Engineer',
  title_es: 'Ingeniero de Software',
  subtitle: 'Desenvolvedor Backend · Orquestração de IA, Automação e Sistemas Multi-Agente',
  subtitle_en: 'Backend Developer · AI Orchestration, Automation & Multi-Agent Systems',
  subtitle_es: 'Desarrollador Backend · Orquestración de IA, Automatización y Sistemas Multi-Agente',
  
  description: `Engenheiro de Software especializado em arquitetura backend, desenvolvimento de APIs robustas e orquestração de sistemas de inteligência artificial de ponta a ponta: sistemas multiagente autônomos, protocolo MCP (Model Context Protocol), RAG (Retrieval-Augmented Generation) e automação web avançada.

Domínio técnico em Python (FastAPI, Flask, Celery), Node.js / TypeScript (NestJS, Express), bancos de dados relacionais e em memória (PostgreSQL, Redis, MySQL), conteinerização com Docker e infraestrutura de servidores Linux (Fedora, Debian, Ubuntu) em nuvem (Oracle Cloud ARM, AWS, Vercel).

Perfil híbrido técnico-comercial com atuação de destaque no desenvolvimento de plataformas B2B de missão crítica — como o MilSelect Web App —, automação e reconciliação fiscal (NF-e, MDF-e, Sintegra, SPC), criação de dashboards analíticos com Power BI e liderança em projetos internacionais. Comprometido com Clean Code, Domain-Driven Design (DDD), segurança da informação (OWASP Top 10, LGPD) e esteiras CI/CD eficientes.`,

  description_en: `Software Engineer specialized in backend architecture, robust API development, and end-to-end AI systems orchestration: autonomous multi-agent systems, Model Context Protocol (MCP), Retrieval-Augmented Generation (RAG), and advanced web automation.

Technical mastery in Python (FastAPI, Flask, Celery), Node.js / TypeScript (NestJS, Express), relational and in-memory databases (PostgreSQL, Redis, MySQL), containerization with Docker, and Linux server infrastructure (Fedora, Debian, Ubuntu) across cloud environments (Oracle Cloud ARM, AWS, Vercel).

Hybrid technical-commercial profile with proven impact in developing mission-critical B2B platforms — such as the MilSelect Web App —, fiscal automation and compliance (NF-e, MDF-e, Sintegra, SPC), real-time analytical dashboards with Power BI, and international project leadership. Committed to Clean Code, Domain-Driven Design (DDD), information security (OWASP Top 10, LGPD), and robust CI/CD pipelines.`,

  description_es: `Ingeniero de Software especializado en arquitectura backend, desarrollo de APIs robustas y orquestación de sistemas de inteligencia artificial de extremo a extremo: sistemas multiagente autónomos, protocolo MCP (Model Context Protocol), RAG (Retrieval-Augmented Generation) y automatización web avanzada.

Dominio técnico en Python (FastAPI, Flask, Celery), Node.js / TypeScript (NestJS, Express), bases de datos relacionales y en memoria (PostgreSQL, Redis, MySQL), contenerización con Docker e infraestructura de servidores Linux (Fedora, Debian, Ubuntu) en la nube (Oracle Cloud ARM, AWS, Vercel).

Perfil híbrido técnico-comercial con experiencia comprobada en el desarrollo de plataformas B2B de misión crítica — como MilSelect Web App —, automatización y conciliación fiscal (NF-e, MDF-e, Sintegra, SPC), creación de dashboards analíticos con Power BI y liderazgo en proyectos internacionales. Comprometido con Clean Code, Domain-Driven Design (DDD), seguridad de la información (OWASP Top 10, LGPD) y pipelines de CI/CD eficientes.`,

  stats: [
    {
      id: 1,
      number: '5+',
      label: 'Anos de Experiência',
      label_en: 'Years of Experience',
      label_es: 'Años de Experiencia',
      description: 'Em desenvolvimento e infraestrutura',
      description_en: 'In software development and infrastructure',
      description_es: 'En desarrollo e infraestructura'
    },
    {
      id: 2,
      number: '50+',
      label: 'Projetos Entregues',
      label_en: 'Projects Delivered',
      label_es: 'Proyectos Entregados',
      description: 'Sistemas B2B, SaaS, IA e infraestrutura',
      description_en: 'B2B systems, SaaS, AI and infrastructure',
      description_es: 'Sistemas B2B, SaaS, IA e infraestructura'
    },
    {
      id: 3,
      number: '13+',
      label: 'Certificações',
      label_en: 'Certifications',
      label_es: 'Certificaciones',
      description: 'Google, Alura e Uniamérica',
      description_en: 'Google, Alura and Uniamérica',
      description_es: 'Google, Alura y Uniamérica'
    },
    {
      id: 4,
      number: '100%',
      label: 'Satisfação',
      label_en: 'Client Satisfaction',
      label_es: 'Satisfacción',
      description: 'Avaliação máxima em entregas',
      description_en: 'Top rating across deliverables',
      description_es: 'Máxima calificación en entregas'
    }
  ],

  experiences: [
    {
      id: 1,
      title: 'Analista de TI & Suporte Comercial',
      title_en: 'IT Analyst & Commercial Support',
      title_es: 'Analista de TI y Soporte Comercial',
      company: 'Mil Select Industrial',
      period: 'Fev 2026 – Presente',
      period_en: 'Feb 2026 – Present',
      period_es: 'Feb 2026 – Presente',
      type: 'CLT · Nilo Peçanha, BA',
      description: 'Responsável pela infraestrutura de TI corporativa (servidores Linux, redes e segurança da informação) e desenvolvimento da plataforma de inteligência comercial MilSelect Web App (NestJS, React, PostgreSQL e Docker). Gestão operacional B2B: ciclo completo de pedidos, emissão/reconciliação fiscal (NF-e, MDF-e, Sintegra, SPC) e dashboards analíticos de KPIs em Power BI e Excel.',
      description_en: 'Responsible for corporate IT infrastructure (Linux servers, networking, and information security) and development of the MilSelect Web App commercial intelligence platform (NestJS, React, PostgreSQL, Docker). B2B operational management: full order cycle, fiscal emission/reconciliation (NF-e, MDF-e, Sintegra, SPC), and KPI analytical dashboards in Power BI and Excel.',
      description_es: 'Responsable de la infraestructura de TI corporativa (servidores Linux, redes y seguridad de la información) y desarrollo de la plataforma de inteligencia comercial MilSelect Web App (NestJS, React, PostgreSQL, Docker). Gestión operativa B2B: ciclo completo de pedidos, emisión/conciliación fiscal (NF-e, MDF-e, Sintegra, SPC) y dashboards analíticos de KPIs en Power BI y Excel.',
      technologies: ['NestJS', 'React', 'PostgreSQL', 'Docker', 'Linux', 'Power BI', 'ERP', 'Sintegra/SPC', 'NF-e / MDF-e']
    },
    {
      id: 2,
      title: 'Engenheiro de Software Backend & AI Solutions',
      title_en: 'Backend Software Engineer & AI Solutions',
      title_es: 'Ingeniero de Software Backend & AI Solutions',
      company: 'Freelancer Internacional',
      company_en: 'International Freelancer',
      company_es: 'Freelancer Internacional',
      period: '2023 – 2026',
      type: 'Remoto · Global',
      type_en: 'Remote · Global',
      type_es: 'Remoto · Global',
      description: 'Arquitetura e desenvolvimento de APIs RESTful escaláveis, microsserviços em Python (FastAPI/Flask) e Node.js/TypeScript, pipelines assíncronos com Redis/Celery e orquestração de sistemas de IA (Multi-Agent, MCP e RAG). Otimização de bancos de dados PostgreSQL, pipelines CI/CD e hardening de servidores Linux sob padrões OWASP e LGPD.',
      description_en: 'Architecture and development of scalable RESTful APIs, microservices in Python (FastAPI/Flask) and Node.js/TypeScript, asynchronous pipelines with Redis/Celery, and AI systems orchestration (Multi-Agent, MCP, RAG). PostgreSQL optimization, CI/CD pipelines, and Linux server hardening following OWASP and LGPD standards.',
      description_es: 'Arquitectura y desarrollo de APIs RESTful escalables, microservicios en Python (FastAPI/Flask) y Node.js/TypeScript, pipelines asíncronos con Redis/Celery y orquestación de sistemas de IA (Multi-Agent, MCP, RAG). Optimización de bases de datos PostgreSQL, pipelines CI/CD y hardening de servidores Linux bajo estándares OWASP y LGPD.',
      technologies: ['Python', 'FastAPI', 'Node.js', 'TypeScript', 'PostgreSQL', 'Redis', 'Docker', 'Linux', 'MCP / AI Agents']
    },
    {
      id: 3,
      title: 'Lead Developer — E-commerce B2B',
      title_en: 'Lead Developer — B2B E-commerce',
      title_es: 'Lead Developer — E-commerce B2B',
      company: 'Outlier Internacional',
      period: '2024 – 2025',
      type: 'Liderança Técnica · Remoto',
      type_en: 'Tech Lead · Remote',
      type_es: 'Liderazgo Técnico · Remoto',
      description: 'Liderança técnica de plataforma e-commerce B2B internacional. Arquitetura de microserviços, coordenação técnica de equipe e integração com gateways de pagamento, cálculo de frete e APIs externas. Stack React.js + Node.js + PostgreSQL, com deploy de alta disponibilidade na AWS.',
      description_en: 'Technical leadership of an international B2B e-commerce platform. Microservices architecture, technical team coordination, and integration with payment gateways, shipping, and third-party APIs. Stack React.js + Node.js + PostgreSQL, with high availability deployment on AWS.',
      description_es: 'Liderazgo técnico de plataforma de e-commerce B2B internacional. Arquitectura de microservicios, coordinación técnica de equipo e integración con pasarelas de pago, logística y APIs de terceros. Stack React.js + Node.js + PostgreSQL, con despliegue de alta disponibilidad en AWS.',
      technologies: ['Node.js', 'React.js', 'PostgreSQL', 'AWS', 'Docker', 'Microserviços', 'REST APIs']
    },
    {
      id: 4,
      title: 'Consultor Técnico & Suporte Especializado',
      title_en: 'Technical Consultant & Specialized Support',
      title_es: 'Consultor Técnico y Soporte Especializado',
      company: 'Autônomo',
      company_en: 'Self-employed',
      company_es: 'Autónomo',
      period: '2021 – 2023',
      type: 'Presencial · Remoto',
      type_en: 'On-site · Remote',
      type_es: 'Presencial · Remoto',
      description: 'Suporte técnico corporativo presencial e remoto, planejamento e administração de infraestrutura de TI, redes estruturadas, manutenção de servidores e treinamento de equipes técnicas.',
      description_en: 'On-site and remote corporate IT support, planning and administration of IT infrastructure, structured networking, server maintenance, and technical staff training.',
      description_es: 'Soporte técnico corporativo presencial y remoto, planificación y administración de infraestructura de TI, redes estructuradas, mantenimiento de servidores y capacitación de equipos técnicos.',
      technologies: ['Suporte TI', 'Infraestrutura', 'Redes', 'Linux', 'Hardware', 'Treinamento']
    }
  ],

  education: [
    {
      id: 1,
      degree: 'Pós-Graduação em Engenharia de Software',
      degree_en: 'Postgraduate in Software Engineering',
      degree_es: 'Posgrado en Ingeniería de Software',
      institution: 'Uniamérica',
      period: '2025 (Concluído)',
      period_en: '2025 (Completed)',
      period_es: '2025 (Completado)',
      status: 'completed',
      description: 'Especializações avançadas: Cibersegurança, BI & Big Data e Desenvolvimento Mobile.',
      description_en: 'Advanced specializations: Cybersecurity, BI & Big Data, and Mobile Development.',
      description_es: 'Especializaciones avanzadas: Ciberseguridad, BI & Big Data y Desarrollo Mobile.'
    },
    {
      id: 2,
      degree: 'Tecnólogo em Análise e Desenvolvimento de Sistemas',
      degree_en: 'Associate Degree in Systems Analysis and Development',
      degree_es: 'Tecnólogo en Análisis y Desarrollo de Sistemas',
      institution: 'Uniamérica',
      period: '2022 – 2025 (Concluído)',
      period_en: '2022 – 2025 (Completed)',
      period_es: '2022 – 2025 (Completado)',
      status: 'completed',
      description: 'Formação sólida em arquitetura de software, estruturas de dados, algoritmos e sistemas distribuídos.',
      description_en: 'Solid foundation in software architecture, data structures, algorithms, and distributed systems.',
      description_es: 'Formación sólida en arquitectura de software, estructuras de datos, algoritmos y sistemas distribuidos.'
    }
  ],

  specializations: [
    {
      id: 1,
      title: 'Orquestração de IA & Multi-Agente',
      title_en: 'AI Orchestration & Multi-Agent',
      title_es: 'Orquestración de IA y Multi-Agente',
      institution: 'Autônomo / Projetos Práticos',
      icon: '🤖',
      description: 'Sistemas autônomos multiagente, protocolo MCP, RAG, automação web e pipelines multi-provider de LLMs.',
      description_en: 'Autonomous multi-agent systems, MCP protocol, RAG, web automation, and multi-provider LLM pipelines.',
      description_es: 'Sistemas autónomos multiagente, protocolo MCP, RAG, automatización web y pipelines multi-provider de LLMs.'
    },
    {
      id: 2,
      title: 'Cibersegurança',
      title_en: 'Cybersecurity',
      title_es: 'Ciberseguridad',
      institution: 'Uniamérica',
      icon: '🛡️',
      description: 'Segurança ofensiva e defensiva, OWASP Top 10, hardening de servidores Linux, auditoria e conformidade LGPD.',
      description_en: 'Offensive and defensive security, OWASP Top 10, Linux server hardening, auditing, and LGPD compliance.',
      description_es: 'Seguridad ofensiva y defensiva, OWASP Top 10, hardening de servidores Linux, auditoría y conformidad LGPD.'
    },
    {
      id: 3,
      title: 'BI & Big Data',
      title_en: 'BI & Big Data',
      title_es: 'BI & Big Data',
      institution: 'Uniamérica',
      icon: '📊',
      description: 'Business Intelligence, pipelines de dados, modelagem analítica, dashboards interativos em tempo real e Power BI.',
      description_en: 'Business Intelligence, data pipelines, analytical modeling, real-time interactive dashboards, and Power BI.',
      description_es: 'Business Intelligence, pipelines de datos, modelado analítico, dashboards interactivos en tiempo real y Power BI.'
    },
    {
      id: 4,
      title: 'Desenvolvimento Mobile & Distribuído',
      title_en: 'Mobile & Distributed Dev',
      title_es: 'Desarrollo Mobile y Distribuido',
      institution: 'Uniamérica',
      icon: '📱',
      description: 'Desenvolvimento de aplicações mobile modernas, arquitetura de microsserviços e integração em nuvem.',
      description_en: 'Modern mobile app development, microservices architecture, and cloud integration.',
      description_es: 'Desarrollo de aplicaciones móviles modernas, arquitectura de microservicios e integración en la nube.'
    }
  ],

  languages: [
    {
      id: 1,
      language: 'Português',
      language_en: 'Portuguese',
      language_es: 'Portugués',
      level: 'Nativo',
      level_en: 'Native',
      level_es: 'Nativo',
      percentage: 100
    },
    {
      id: 2,
      language: 'Inglês',
      language_en: 'English',
      language_es: 'Inglés',
      level: 'Intermediário',
      level_en: 'Intermediate',
      level_es: 'Intermedio',
      percentage: 70
    },
    {
      id: 3,
      language: 'Espanhol',
      language_en: 'Spanish',
      language_es: 'Español',
      level: 'Intermediário',
      level_en: 'Intermediate',
      level_es: 'Intermedio',
      percentage: 65
    }
  ],

  interests: [
    'Sistemas Multi-Agente & MCP',
    'Orquestração de IA & RAG',
    'Arquitetura Backend & Microsserviços',
    'Cibersegurança & Hardening',
    'DevOps & Infraestrutura Linux',
    'Business Intelligence & Big Data',
    'Desenvolvimento Web 3D',
    'Open Source & Automação'
  ]
};